export default "dist/images/components-columns-width-control-2-3-grid.f25924c.png";